module.exports = __webpack_public_path__ + "img/manual3-1.a86da932.png";